module.exports = __webpack_public_path__ + "assets/img/fashion-img3-a8119fc3.png";